import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logoMain from '../img/tasaciones_logo.png';
import logoLetter from '../img/tasacionesya_letter.png';
import { FaBars, FaTimes, FaUser } from 'react-icons/fa';


const Navbar = ({ isLoggedIn, onLoginClick, onRegisterClick, onLogout, userInfo, onNavigateToMetrics, onNavigateToUsers, onAgentDashboardClick = () => {} }) => {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLoginClick = (e) => {
        e.preventDefault();
        onLoginClick();
    };
    
    const handleRegisterClick = (e) => {
        e.preventDefault();
        setIsMenuOpen(false);
        onRegisterClick();
    };

    const handleLogout = (e) => {
        e.preventDefault();
        onLogout();
    };

    const handleMetricsClick = (e) => {
        e.preventDefault();
        onNavigateToMetrics();
    };
    
    const handleUsersClick = (e) => {
        e.preventDefault();
        onNavigateToUsers();
        setIsMenuOpen(false);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Define the color codes
    const primaryColor = '#8360C3';
    const secondaryColor = '#2EBF91';

    // Inline styles
    const styles = {
        navbar: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 15px',
            backgroundColor: '#fff',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            borderBottom: `1px solid ${primaryColor}`,
            width: '100%',
            boxSizing: 'border-box',
        },
        logoContainer: {
            display: 'flex',
            alignItems: 'center',
            flex: isMobile ? '1' : 'none',
            justifyContent: isMobile ? 'center' : 'flex-start',
        },
        letterContainer: {
            display: isMobile ? 'none' : 'flex',
            flex: 1,
            justifyContent: 'center',
        },
        loginLinkContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        logoImage: {
            height: '35px',
        },
        letterImage: {
            height: '35px',
        },
        loginLink: {
            textDecoration: 'none',
            color: primaryColor,
            marginLeft: '8px',
            paddingRight: '20px',
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
        },
        loginIcon: {
            marginRight: '5px',
        },
        hamburgerMenu: {
            display: isMobile ? 'block' : 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: primaryColor,
        },
        menuOpen: {
            display: isMenuOpen && isMobile ? 'block' : 'none',
            position: 'absolute',
            top: '60px',
            right: '10px',
            backgroundColor: '#fff',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            padding: '10px',
            borderRadius: '4px',
            zIndex: '1000',
            width: '200px',
            boxSizing: 'border-box',
        },
        menuItem: {
            display: 'block',
            padding: '10px',
            textDecoration: 'none',
            color: secondaryColor,
        },
        desktopOnly: {
            display: isMobile ? 'none' : 'flex',
            alignItems: 'center',
        },
    };

    return (
        <>
            <div style={styles.navbar}>
                <div style={styles.logoContainer}>
                    <img 
                        src={logoMain} 
                        alt="Logo" 
                        style={styles.logoImage}
                    />
                </div>
                <div style={styles.letterContainer}>
                    <img 
                        src={logoLetter} 
                        alt="Tasaciones Letter" 
                        style={styles.letterImage}
                    />
                </div>
                <div 
                    style={styles.hamburgerMenu} 
                    onClick={toggleMenu}
                >
                    {isMenuOpen ? <FaTimes /> : <FaBars />}
                </div>
                <div style={styles.desktopOnly}>
                    {isLoggedIn ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{ color: primaryColor, fontSize: '14px' }}>
                                Hola, {userInfo?.userType === 'agent' ? (userInfo?.name || userInfo?.email) : (userInfo?.email || 'Usuario')}
                            </span>
                            {userInfo?.userType === 'Admin' && (
                                <>
                                    <a href="#" style={styles.loginLink} onClick={handleMetricsClick}>
                                        📊 Métricas
                                    </a>
                                    <a href="#" style={styles.loginLink} onClick={handleUsersClick}>
                                        👥 Usuarios
                                    </a>
                                </>
                            )}
                            {userInfo?.userType === 'agent' && (
                                <a href="#" style={styles.loginLink} onClick={(e) => {
                                    e.preventDefault();
                                    onAgentDashboardClick();
                                }}>
                                    🏠 Panel
                                </a>
                            )}
                            <a href="#" style={styles.loginLink} onClick={handleLogout}>
                                Cerrar sesión
                            </a>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <a href="#" style={styles.loginLink} onClick={handleLoginClick}>
                                <FaUser style={styles.loginIcon} />
                                Ingresar
                            </a>
                            <button
                                onClick={handleRegisterClick}
                                style={{
                                    background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                    color: 'white',
                                    border: 'none',
                                    padding: '6px 12px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    whiteSpace: 'nowrap'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-1px)';
                                    e.target.style.boxShadow = '0 4px 12px rgba(40, 167, 69, 0.3)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = 'none';
                                }}
                            >
                                📝 Registrarse
                            </button>
                        </div>
                    )}
                </div>
                {isMenuOpen && (
                    <div style={styles.menuOpen}>
                        {isLoggedIn ? (
                            <div>
                                <div style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                                    Hola, {userInfo?.userType === 'agent' ? (userInfo?.name || userInfo?.email) : (userInfo?.email || 'Usuario')}
                                </div>
                                {userInfo?.userType === 'Admin' && (
                                    <>
                                        <a href="#" style={styles.menuItem} onClick={handleMetricsClick}>
                                            📊 Métricas
                                        </a>
                                        <a href="#" style={styles.menuItem} onClick={handleUsersClick}>
                                            👥 Usuarios
                                        </a>
                                    </>
                                )}
                                {userInfo?.userType === 'agent' && (
                                    <a href="#" style={styles.menuItem} onClick={(e) => {
                                        e.preventDefault();
                                        setIsMenuOpen(false);
                                        onAgentDashboardClick();
                                    }}>
                                        🏠 Panel
                                    </a>
                                )}
                                <a href="#" style={styles.menuItem} onClick={handleLogout}>
                                    Cerrar sesión
                                </a>
                            </div>
                        ) : (
                            <div>
                                <a href="#" style={styles.menuItem} onClick={handleLoginClick}>
                                    <FaUser style={styles.loginIcon} />
                                    Ingresar
                                </a>
                                <a href="#" style={{
                                    ...styles.menuItem,
                                    background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                    color: 'white',
                                    borderRadius: '6px',
                                    marginTop: '8px',
                                    textAlign: 'center',
                                    fontSize: '13px',
                                    padding: '8px 12px'
                                }} onClick={handleRegisterClick}>
                                    📝 Registrarse
                                </a>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default Navbar;
